<template>
  <div class="main-container">
    <div class="cart-container" v-if="this.formStep === 0">
      <Cart />
      <!--       <div>
        <a-button
          class="checkout-button"
          type="secondary"
          @click.prevent="handleContinueShopping()"
        >
          ← Continue Shopping
        </a-button>

        <a-button
          v-if="this.cartItems.length > 0"
          class="checkout-button green"
          type="primary"
          @click.prevent="handleCheckout()"
        >
          Confirm Order →
        </a-button>
      </div> -->
    </div>
    <div v-if="this.formStep !== 0">
      <div class="step-container">
        <!--         <div class="step-div">
          <div
            :class="
              this.formStep === 1 ? 'step-count active' : 'step-count inactive'
            "
          >
            1
          </div>
          <div class="step-header">Delivery Location</div>
        </div>
        <div class="step-div">
          <div
            :class="
              this.formStep === 2 ? 'step-count active' : 'step-count inactive'
            "
          >
            2
          </div>
          <div class="step-header">Personal Details</div>
        </div>
        <div class="step-div">
          <div
            :class="
              this.formStep === 3 ? 'step-count active' : 'step-count inactive'
            "
          >
            3
          </div>
          <div class="step-header">Order Confirm & Payment</div>
        </div> -->
      </div>
      <div v-if="formStep === 1" class="step-items-map">
        <div class="map-wrapper">
          <LocationForm />
        </div>
      </div>
      <div v-if="formStep === 2">
        <div>
          <DetailsForm />
        </div>
      </div>
      <div v-if="formStep === 3">
        <div>
          <PaymentForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src\
import { mapGetters, mapActions } from "vuex";
import { MenuService } from "../../services/items.service";
import { LocationId, CartData } from "../../services/storage.service";
import router from "../../router";
import { format } from "date-fns";

import Banner from "../../components/Banner.vue";

import Cart from "./Cart.vue";
import UserInfo from "./UserInfo.vue";
import LocationForm from "./StepOrder/LocationForm.vue";
import DetailsForm from "./StepOrder/DetailsForm.vue";
import PaymentForm from "./StepOrder/PaymentForm.vue";

import WizardFooter from "../../components/FloatingFooter/WizardFooter";

import axios from "axios";

export default {
  name: "OrderWizard",
  components: {
    Banner,
    Cart,
    UserInfo,
    LocationForm,
    DetailsForm,
    PaymentForm,
    WizardFooter,
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "locationMarker",
      "formStep",
      "getOrderError",
      "cartTotal",
    ]),
    showObject: function () {
      return {
        hide: this.cartItems.length === 0,
      };
    },
  },
  methods: {
    ...mapActions(["clearCart", "setMinOrder", "updateStep"]),

    getMinOrder: function () {
      // console.log(MenuService);

      MenuService.getItems(1, parseInt(LocationId.getLocationId()))
        .then((data) => {
          this.setMinOrder(data.minimum_order);
          // console.log("Min :" + data.minimum_order);
        })
        .catch((err) => console.log(err));
    },

    handleContinueShopping() {
      router.push("/:loc?");
    },

    handleCheckout() {
      if (this.cartTotal < 500) {
        this.$message.warning(`"Cart should be atleast of NRs. 500."`);
      } else {
        this.updateStep(1);
      }
    },

    handlePaymentLink() {
      let routeData = this.$router.resolve({ name: "OrderStatus" });
      window.open(routeData.href, "_blank");
    },

    getDate() {
      const date = format(new Date(), "MM/dd/yyyy");
      return date;
    },

    createFonePaySignature() {
      let signature = [
        {
          PID: "NBQM", // merchant code
          MD: "P", // transaction mode (maybe)
          PRN: "001001001001003", // product reference number
          AMT: 300, // bill amount
          CRN: "NPR", // nepalese rupees
          DT: this.getDate(), // date
          R1: "Hello", // remarks 1
          R2: "Test", //remarks 2
          RU: "https://devadminapi.fonepay.com/ConvergentMerchantDummyweb/MerchantVerification", // return url
        },
      ];

      const conStr = signature.reduce(
        (str, v, i) => str + `${i ? "," : ""}${Object.values(v)}`,
        ""
      );

      const conStr1 =
        "NBQM,P,d1580724437729,30,NPR,06/27/2017,Hello,test remarks,https://devadminapi.fonepay.com/ConvergentMerchantDummyweb/MerchantVerification";

      const crypto = require("crypto");

      const hash = crypto
        .createHmac("sha512", "a7e3512f5032480a83137793cb2021dc")
        .update(conStr)
        .digest("hex");

      this.handleFonepayPayment(hash);
    },

    handleFonepayPayment(hash) {
      const path = "https://dev-clientapi.fonepay.com/api/merchantRequest";

      const params = {
        PID: "NBQM", // merchant code
        MD: "P", // transaction mode (maybe)
        PRN: "001001001001003", // product reference number
        AMT: 300, // bill amount
        CRN: "NPR", // nepalese rupees
        DT: this.getDate(), // date
        R1: "Hello", // remarks 1
        R2: "Test", //remarks 2
        RU: "https://devadminapi.fonepay.com/ConvergentMerchantDummyweb/MerchantVerification", // return url
        DV: hash,
      };

      const form = document.createElement("form");

      form.setAttribute("method", "GET");
      form.setAttribute("action", path);

      for (let key in params) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);

      form.submit();
    },
  },
  created() {
    window.scrollTo(0, 0);
    this.getMinOrder();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@mixin flexbox() {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-button-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .custom-button {
    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        color: #fff;
      }
    }
    &.hide {
      display: none;
    }
  }
}
.step-items-payment {
  position: relative;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-top: 20px;

  .payment-wrapper {
    width: 70%;
    height: 100%;
  }
}
.step-items-form {
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: scroll;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  margin-top: 20px;

  .form-wrapper {
    width: 70%;
    // height: 100%;
  }
}
/* .step-items-map {
  position: relative;
  margin-top: 20px;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  .map-wrapper {
    width: 70%;
    height: 100%;
  }
} */
.main-container {
  background-color: #fff;
  margin-top: 80px;
}
.step-container {
  @include flexbox();

  // background-image: linear-gradient(180deg, #d1b4b4, #ffffff);
}
.step-div {
  @include flexbox();
  flex-direction: column;
  margin: 0px 40px;
  text-align: center;
}
.step-count {
  @include flexbox();
  height: 26px;
  width: 26px;
  border-radius: 4px;
  color: #fff;
  font-family: $main-font;
  font-size: 12px;
}
.active {
  background-color: #ed3c3b;
}
.inactive {
  background-color: rgb(130, 130, 133);
}
.step-header {
  margin-top: 5px;
  font-family: $main-font;
  font-size: 14px;
  font-weight: 500;
  color: #000;
}
.cart-container {
  @include flexbox();
  flex-direction: column;
  margin-bottom: 90px;
}
.checkout-button {
  padding: 10px;
  height: auto;
  cursor: pointer;
  font-family: $main-font;
  text-transform: uppercase;
  border-radius: 4px;
  margin: 0px 10px;
}

.green {
  background: #60b246;
  border-color: #60b264;
}

/* @media only screen and (max-width: 740px) {
  .step-div {
    @include flexbox();
    flex-direction: column;
    margin: 0px 10px;
    text-align: center;

    .step-header {
      font-size: 12px;
      font-weight: 600;
    }
  }

  .step-items-map {
    margin-top: 20px;
    height: 350px;
  }

  .step-items-form {
    margin-top: 20px;
  }

  .step-items-payment {
    margin-top: 20px;
  }
} */
</style>
